export default __webpack_public_path__ + "static/media/logo.d22493ad.jpg";